import {z} from 'zod';

export const DEFAULT_PAGE_SIZE = 25;
export const MAX_PAGE_SIZE = 100;

export const pagingSchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  size: z.coerce.number().int().min(1).max(MAX_PAGE_SIZE).default(DEFAULT_PAGE_SIZE),
});

export type Paging = z.infer<typeof pagingSchema>;

export interface Page<T> {
  items: T[];
  page: number;
  size: number;
  total: number;
}

export const toPage = <T>(items: T[], paging: Paging, total: number): Page<T> => ({
  items,
  page: paging.page,
  size: paging.size,
  total,
});

export const offsetOf = (paging: Paging): number => (paging.page - 1) * paging.size;

/** Response contract for any paged endpoint, so the frontend validates what it renders. */
export const pageSchemaOf = <T extends z.ZodType>(item: T) =>
  z.object({
    items: z.array(item),
    page: z.number().int(),
    size: z.number().int(),
    total: z.number().int(),
  });
